<template>
  <div class="attribute">
    <div class="attr-label"><p>{{ label }}</p></div>
    <div class="attr-items">
      <div class="item" @click="selectColor(color)" :class="{ 'active': (modelValue && modelValue.id === color.id), 'border' : (color.nom === 'BLANC') }" v-for="(color, index) in phone.colors" :key="index"><span class="color" :style="{ backgroundColor: '#' + color.hex }"></span>{{ color.nom.toLowerCase() }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Color',
  props: {
    modelValue: Object,
    label: String
  },
  computed: {
    ...mapState({
      color: state => state.phone.color,
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    })
  },
  methods: {
    selectColor (color) {
      this.$emit('update:modelValue', color)
      this.$emit('change')
    }
  },
  watch: {
    color (value) {
      this.selectColor(value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.attribute{
  margin-bottom: 20px;

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontRegular;
    }
  }

  .attr-items{
    .item{
      width: auto;
      height: 50px;
      line-height: 28px;
      border: 1px solid darken($white, 10%);
      margin: 0 10px 10px 0;
      position: relative;
      cursor: pointer;
      padding: 10px 15px 10px 15px;
      text-transform: capitalize;
      @include radius(5px);
      @include transition();

      &:after {
        display: inline-block;
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border: 2px solid $black;
        opacity: 0;
        @include radius(5px);
        @include transition();
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;

        &:after {
          opacity: 1;
          border: 2px solid $primary;
        }
      }

      &.border{
        span.color{
          border: 1px solid darken($white, 30%);
        }
      }

      span.color {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        margin-right: 10px;
        @include transform(translateY(-1px));
        @include radius(100%);
      }
    }
  }
}
</style>
